import { useParams, Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft, ArrowRight, CalendarDays, Clock } from "lucide-react";
import { BLOG_POSTS } from "@/lib/data";
import { ARTICLE_HTML } from "@/lib/articles";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return iso;
  }
}

export default function BlogArticle() {
  const { slug } = useParams();
  const post = BLOG_POSTS.find((p) => p.slug === slug);
  const html = ARTICLE_HTML[slug];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  return (
    <div data-testid="blog-article-page">
      <section className="max-w-3xl mx-auto px-6 lg:px-10 pt-16 pb-8">
        <Link
          to="/blog"
          data-testid="article-back"
          className="inline-flex items-center gap-2 text-sm text-[#8B7E74] hover:text-[#4A403A] link-underline mb-8"
        >
          <ArrowLeft size={15} /> Retour au blog
        </Link>

        {post && (
          <div className="flex flex-wrap items-center gap-3 text-xs text-[#8B7E74]">
            <span className="tracking-[0.18em] uppercase text-[#BA8E82] bg-[#F4EBE6] rounded-full px-3 py-1">{post.tag}</span>
            <span className="inline-flex items-center gap-1"><CalendarDays size={12} /> {formatDate(post.date)}</span>
            <span className="inline-flex items-center gap-1"><Clock size={12} /> 4 min de lecture</span>
          </div>
        )}
      </section>

      {html ? (
        <article data-testid="article-content" dangerouslySetInnerHTML={{ __html: html }} />
      ) : (
        <section className="max-w-3xl mx-auto px-6 lg:px-10 py-24 text-center">
          <h1 className="font-serif text-4xl md:text-5xl text-[#4A403A] mb-6">
            {post ? post.title : "Article introuvable"}
          </h1>
          <p className="text-[#8B7E74] leading-relaxed max-w-xl mx-auto mb-8">
            {post
              ? "Cet article est en cours de rédaction. Léa le publiera très bientôt — revenez vite !"
              : "Cet article n'existe pas ou a été déplacé."}
          </p>
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 rounded-full px-7 py-3 bg-[#4A403A] text-[#FAF7F2] text-sm tracking-wide transition-all hover:-translate-y-0.5"
          >
            <ArrowLeft size={15} /> Retour au blog
          </Link>
        </section>
      )}

      {/* CTA */}
      <section className="max-w-5xl mx-auto px-6 lg:px-10 py-20">
        <div className="bg-[#4A403A] rounded-[2rem] px-10 md:px-16 py-14 md:py-16 text-center">
          <h3 className="font-serif text-3xl md:text-4xl text-[#FAF7F2] mb-5">
            Besoin d'un accompagnement sur mesure&nbsp;?
          </h3>
          <p className="text-[#FAF7F2]/80 mb-8 max-w-xl mx-auto">
            Chaque enfant est unique. Le 1<sup>er</sup> appel est gratuit — parlons de votre situation.
          </p>
          <Link
            to="/rendez-vous"
            data-testid="article-cta-booking"
            className="inline-flex items-center gap-2 rounded-full px-8 py-3.5 bg-[#D2A69A] text-[#4A403A] text-sm tracking-wide transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#FAF7F2]"
          >
            Prendre rendez-vous <ArrowRight size={15} />
          </Link>
        </div>
      </section>
    </div>
  );
}
